<template>
 <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
       <div class="col-md-6">
         <div class="box">
           <div class="box-header">
             <h3 class="box-title">On/Off</h3>
           </div>
           <div class="box-body no-padding table-responsive">
             <table class="table table-striped">
               <thead>
                 <tr>
                   <th>Variável</th>
                   <th style="width: 40px">Valor</th>
                 </tr>
               </thead>
                <tbody  v-if="idioma === 'DE'">
                 <tr v-for="registro in  orderBy(filterBy(registros, true, 'is_bool'), 'labelDe')"  :key="registro.id">
                   <td>{{registro.labelDe}}</td>
                   <td>
                    <div>
                      <span class="badge bg-green" v-if="registro.valor === 1">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                 </tr>
               </tbody>
                <tbody v-else-if="idioma === 'EN'">
                 <tr v-for="registro in  orderBy(filterBy(registros, true, 'is_bool'), 'labelEn')"  :key="registro.id">
                   <td>{{registro.labelEn}}</td>
                   <td>
                    <div>
                      <span class="badge bg-green" v-if="registro.valor === 1">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                 </tr>
               </tbody>
               <tbody v-else-if="idioma === 'ES'">
                 <tr v-for="registro in  orderBy(filterBy(registros, true, 'is_bool'), 'labelEs')"  :key="registro.id">
                   <td>{{registro.labelEs}}</td>
                   <td>
                    <div>
                      <span class="badge bg-green" v-if="registro.valor === 1">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                 </tr>
               </tbody>
               <tbody v-else>
                 <tr v-for="registro in  orderBy(filterBy(registros, true, 'is_bool'), 'labelPtBr')"  :key="registro.id">
                   <td>{{registro.labelPtBr}}</td>
                   <td>
                    <div>
                      <span class="badge bg-green" v-if="registro.valor === 1">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                 </tr>
               </tbody>
             </table>
           </div>
         </div>
       </div>
       <div class="col-md-6">
         <div class="box">
           <div class="box-header">
             <h3 class="box-title">Valores</h3>
           </div>
           <div class="box-body no-padding table-responsive">
             <table class="table table-striped">
               <thead>
                 <tr>
                   <th>Variável</th>
                   <th style="width: 100px">Valor</th>
                 </tr>
               </thead>
                <tbody  v-if="idioma === 'DE'">
                 <tr v-for="registro in  orderBy(filterBy(registros, false, 'is_bool'), 'labelDe')"  :key="registro.id">
                   <td>{{registro.labelDe}}</td>
                   <td>
                     <div class="float-right">
                      <span class="text-uppercase">
                       {{parseFloat(registro.valor).toFixed(1)}} {{registro.unidade_medida}}
                      </span>
                     </div>
                  </td>
                 </tr>
               </tbody>
                <tbody v-else-if="idioma === 'EN'">
                 <tr v-for="registro in  orderBy(filterBy(registros, false, 'is_bool'), 'labelEn')"  :key="registro.id">
                   <td>{{registro.labelEn}}</td>
                   <td>
                     <div class="float-right">
                      <span class="text-uppercase">
                       {{parseFloat(registro.valor).toFixed(1)}} {{registro.unidade_medida}}
                      </span>
                     </div>
                  </td>
                 </tr>
               </tbody>
               <tbody v-else-if="idioma === 'ES'">
                 <tr v-for="registro in  orderBy(filterBy(registros, false, 'is_bool'), 'labelEs')"  :key="registro.id">
                   <td>{{registro.labelEs}}</td>
                   <td>
                     <div class="float-right">
                      <span class="text-uppercase">
                       {{parseFloat(registro.valor).toFixed(1)}} {{registro.unidade_medida}}
                      </span>
                     </div>
                  </td>
                 </tr>
               </tbody>
               <tbody v-else>
                 <tr v-for="registro in  orderBy(filterBy(registros, false, 'is_bool'), 'labelPtBr')"  :key="registro.id">
                   <td>{{registro.labelPtBr}}</td>
                   <td>
                     <div class="float-right">
                      <span class="text-uppercase">
                       {{parseFloat(registro.valor).toFixed(1)}} {{registro.unidade_medida}}
                      </span>
                     </div>
                  </td>
                 </tr>
               </tbody>
             </table>
           </div>
         </div>
       </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->

   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import config from '../../config'

var db = firebaseApp.database()

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      registros: [],
      paginate: ['dados'],
      idioma: 'PtBr'
    }
  },
  firebase: {
    registros: db.ref(config.project)
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Manutencao.vue?c3754ab4